import { useClient } from '@composables/use-clients';
import { urls } from '@api/urls';
import { withTryCatch } from '@api/v1/error-handlers';
import { DEFAULTS } from '@constants/defaults';

export const apiFetchCurrentUserTenantInvitationCodes = async ({
  query = {
    page: DEFAULTS.API.QUERY.PAGE,
    pageSize: DEFAULTS.API.QUERY.FLEX_LIST_PAGE_SIZE,
  },
  errorConfig = {},
  callbacks = {},
} = {}) => {
  const impl = async () => {
    const { client } = useClient('auth');
    const res = await client.get({
      url: urls.v1.currentUserTenantInvitationCodes(),
      query,
    });
    return res;
  };

  return withTryCatch({ impl, errorConfig, callbacks });
};
